import React, { FC } from "react"
import {
    APIAppInstanceModel,
    mapAppInstanceStatus,
    isAppInstanceArchived
} from "../../../../../../Models/API/AppInstanceModel"
import { Text } from "dash-styled"
import { hasResult } from "../../../../../../Models/Client/FetchState"
import { useAppState } from "../../../../../../Hooks/useReduxState"
import { useAppTemplate } from "../../../../../../Hooks/useAppTemplate"
import { selectIsSysAdmin } from "../../../../../../Helpers/Functions/Selectors/auth"
import { LinkButton } from "../../../../../Common/LinkButton/LinkButton"
import { fromNow } from "../../../../../../Helpers/Functions/dateFormat"

interface CustomerAppInstanceCardProps {
    app: APIAppInstanceModel
    onOpenProject?: (appID: string) => void
}

export const CustomerAppInstanceCard: FC<CustomerAppInstanceCardProps> = ({
    app,
    onOpenProject
}) => {
    const template = useAppTemplate(app.uuid, app.templateName ?? undefined)
    const isSysAdmin = useAppState(selectIsSysAdmin)

    const handleOpenProject = () => onOpenProject?.(app.uuid)

    const isAppArchived = isAppInstanceArchived(app)
    return (
        <div className="mb-2">
            <Text component="span" className="mr-1">
                {hasResult(template)
                    ? template.isError
                        ? "Missing template"
                        : template.value.metadata.name
                    : "Fetching template info..."}
                :
            </Text>
            {isSysAdmin && onOpenProject !== undefined ? (
                <LinkButton onClick={handleOpenProject}>{app.name}</LinkButton>
            ) : (
                <span>{app.name}</span>
            )}
            <Text
                color="coldgreen"
                component="span"
                weight="regular"
                className={`inline-flex m-0 ml-2 items-center font-normal ${
                    isAppArchived ? "text-rhino-900" : ""
                }`}
                size="sm"
            >
                ({mapAppInstanceStatus(app.status).toLowerCase()})
            </Text>
            <Text size="xs" color="gray" className="text-smoke-610 m-0">
                {`Created ${fromNow(app.created)}`}
            </Text>
        </div>
    )
}
